import { FC, Fragment } from 'react';
import * as React from 'react';

import { MainMenuProps, useUITheme } from '@crehana/web';

import { DashboardMenu } from './components';

export type RouteHeaderProps = Pick<MainMenuProps, 'amplitudePageName'> & {
  pageTitle: string;
  contentTitle?: string | React.ReactNode;
  onSearchClick?: () => void;
  onMobileFAQsClick?: () => void;
  supportsDarkMode?: boolean;
  mainMenuProps?: Partial<Omit<MainMenuProps, 'countryPrefix'>>;
};

const RouteHeader: FC<React.PropsWithChildren<RouteHeaderProps>> = ({
  pageTitle,
  contentTitle,
  onSearchClick,
  onMobileFAQsClick,
  supportsDarkMode,
  amplitudePageName,
  mainMenuProps,
}) => {
  const { theme } = useUITheme();
  const isDark = supportsDarkMode && theme === 'dark';

  const contentPageTitle = contentTitle || pageTitle;

  return (
    <Fragment>
      <DashboardMenu
        amplitudePageName={amplitudePageName}
        theme={isDark ? 'dark' : 'light'}
        dashboardTitle={contentPageTitle}
        onDashboardSearchClick={onSearchClick}
        onMobileFAQsClick={onMobileFAQsClick}
        {...mainMenuProps}
        layoutConfig={{
          hideNightSwitch: !supportsDarkMode,
          ...mainMenuProps?.layoutConfig,
        }}
        customThemes={{
          light: {
            ...mainMenuProps?.customThemes?.light,
            nav: {
              backgroundColorClassName: 'bg-gray-lighter',
              ...mainMenuProps?.customThemes?.light?.nav,
            },
          },
          dark: {
            ...mainMenuProps?.customThemes?.dark,
            nav: {
              backgroundColorClassName: 'bg-base-dark',
              ...mainMenuProps?.customThemes?.dark?.nav,
            },
          },
        }}
      />
    </Fragment>
  );
};

export default RouteHeader;
